/*  ******************************************************************************************
 * easytt transcript component
 ****************************************************************************************** */
import React from 'react';
import './transcript.css';
import { last, first, join, groupBy, cloneDeep, isEqual } from 'lodash';

import Search from './components/search/search.js';
import SimplePopup from '../../../../components/bases/popup/simplePopup.js';
import ContextMenu from './components/context-menu/context-menu.js';
import SpeakerMenu from './components/speaker-menu/speaker-menu.js';
import HourglassIcon from './components/hourglass/hourglass.js';

import { calculateTime, cloneTranscription, findMarkWords, wait } from './utils/functions.js';
import { drawStabilo, getColorByShortcut } from '../../../../utils/colors.js';
import { GlobalContext } from '../../../../utils/globalprovider.js';

import checkst from './assets/icons/checkst.png';
import newst from './assets/icons/newst.png';
import cp from './assets/icons/cp.png'
import tcmanual from './assets/icons/tcmanual.png';

import {
  addChar,
  addSpace,
  addHyphen,
  groupWordsWithoutSpace,
  groupWordsByUnsecableSpace,
  onConversionToInitial,
  onUpperOrLowerCase,
  onReturnToLineWithHypen,
  addPeriod,
  removeUnsecableSpace,
  addQuotes,
  addApostrophes,
  addOrRemoveLetter,
  invertPeriodAndComma,
  invertALetter,
  hyphenateTwoWords,
  replaceHyphenate,
  addOrRemoveLetterWithApostrophe,
  addOrRemoveApostropheToLetter,
  replaceLetter,
  addOrRemoveLeToWord,
  addHebrewOrArabicChar,
} from './actions/char.js';

import {
  onMoveCursorLetterByLetter,
  onMoveCursorToLeft,
  onMoveCursorToRight,
  onMoveCursorToDown,
  onMoveCursorToUp,
  onPreviousPositionCursor,
  onGoToStartOrEndOfWord,
  onGoToHomeOrEnd,
  onGoToPageUpOrDown,
  onGoToSentence,
  onGoToSpeakerDialogue,
} from './actions/cursor.js';

import {
  onHandleChangeScroll,
  onWheel,
  onScrollKeyDown,
  onZoom,
} from './actions/scroll.js';

import {
  onDoubleClick,
  onMouseMove,
  onMouseUp,
  onMouseDown,
  onStopMoving,
  onRemoveMoving,
  onBlur,
  onClick,
} from './actions/mouse.js';

import {
  onBackspace,
  onCopy,
  onCut,
  onDelete,
  onDeleteWord,
  onDeleteLine,
  onDeleteWordsUntil,
  onPaste,
  onEnter,
  onMoveWordByWord,
  onSelect,
  onSelectLeftOrRight,
  onSelectTopOrBottom,
  onMarkWord,
  onSetColor,
  onSelectWithCtrlA,
  onSelectSentence,
  onTab,
  onChangeTranscription,
  onSubmitWord,
  onSubmitSentence,
  onCancelSubmittedWords,
  onSelectLetterByLetter,
  onBackspaceLeftToRight,
  onDeleteLeftToRight,
} from './actions/keyboard.js';

import {
  onSearchClose,
  onSearchChange,
  onPrevPositionSearch,
  onNextPositionSearch,
  onReplaceOne,
  onReplaceAll,
  onSearchCaseSensitive,
  onSearchWholeWord,
} from './actions/search.js';

import {
  addNewActionForUndo,
  addActionForUndoOrRedo,
  onUndoOrRedo,
  addNewActionOnUnderSelectionForUndo,
  onUnderSelectionWhenUndoOrRedo,
  onReplaceAllWhenUndoOrRedo,
  onRedrawAfterRedoOrUndo,
  addScriptToNewUndo,
} from './actions/undo-redo.js';

import {
  onScriptChecker,
  onWordChecker,
  onWordCheckerEnglish,
  onCloseContextMenu,
  onShowContextMenu,
  onApplyCorrection,
  onApplyCorrectionForSpelling,
  onApplyCorrectionForSpellingEnglish,
  onApplyCorrectionForGrammar,
  onApplyCorrectionAll,
  onCheckLine,
  onCheckOnLines,
  onCheckLineByWord,
  onAddWordToDictionary,
  onIgnoreWordForCorrection,
  onIgnoreSuggestForCorrection,
  onGoToWordInError,
} from './actions/corrector.js';

import {
  onShowSpeakerMenu,
  onSelectSpeaker,
  onCloseSpeakerMenu,
} from './actions/speaker.js';

import Grammalecte from './actions/grammalecte.js';

import { functionsMixin } from './utils/mixin.js';
import { V2_ConvertSecondToTimeCodeStringFromAsset } from '../../../../utils/timecodev2';

class Transcript extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);




    Object.assign(this, functionsMixin);

    this.script = null;
    this.resizeObserver = null;
    this.commonErrors = null;

    this.readonly = false; // lecteur seule
    this.noCursor = false; // ne pas afficher le curseur
    this.showPosition = false; // on montre la position du mot sans le curseur uniquement en readonly

    this.state = {
      transcription: {
        id: null,
        description: null,
        lang:null,
        hasDisplayOriginal: false,
        original: {
          id: null,
          script: null,
          description: null,
        },
        corrected: {
          id: null,
          script: null,
          description: null,
        },
      },
      maxScrollValue: 100,
      scrollValue: 0,
      totalLines: 0,
      totalWords: 0,
      totalWordsInError: 0,
      currentPositionLine: 0,
      currentPositionWord: 0,
      currentTime: 0,
      font: {
        fontSize: 22,
        baseFontSize: 22,
        fontText: 'Arial',
        px: 1,
      },
      search: {
        showSearch: false,
        showReplace: false,
        searchText: '',
        totalWordsFounded: 0,
        currentPosition: null,
        showSelection: false,
        caseSensitive: false,
        wholeWord: false,
      },
      popup: {
        display: false,
        title: '',
        text: '',
        buttons: [],
        showIcon: false,
        icon: null,
      },
      contextMenu: {
        display: false,
        x: 0,
        y: 0,
        word: null,
      },
      speakerMenu: {
        display: false,
      },
      identifySpeaker: {
        show: false,
        speakerId: null,
        color: null,
      },
    };

    this.searchRef = React.createRef();
    this.speakerMenuRef = React.createRef();

    this.forceRedraw = false; // true s'il faut dessiner à nouveau le back canvas;
    this.forceRecalculateLines = false; // true s'il faut recalculer les lignes dans le canvas pour le scroll

    this.backCanvas = document.createElement('canvas'); // canvas arrière plan
    this.foreCanvas = React.createRef(); // référence vers de canvas affiché
    this.foreCtx = null;
    this.backCtx = null;

    this.width = 0;
    this.height = 0;
    this.metricX = 10;
    this.metricY = 10;
    this.lineHeight = 0;
    this.spaceWidth = 0;

    this.showCptCurs = true;
    this.cptCurs = 0;

    this.nbVisibleLines = 0; // nombre de lignes affichés dans le canvas

    this.currentWordIndex = 0;
    this.currentLineIndex = 0;
    this.currentLetterIndex = 0;

    this._isCursorAtEndOfWord = false; // si le curseur est à la fin du mot

    this.takeFirstLetter = false; // on prend la première lettre ou non lors de la position du curseur

    this.currentWord = null;
    this.currentLetter = null;

    this.scrollOffsetLine = 0; // Offset du scroll de la ligne
    this.scrolling = false; // en cours de scroll
    this.lockScroll = false; // on verrouille ou déverrouille le scroll pour que le scroll ne suive pas l'image
    this.moving = false; // en cours de déplacement
    this.typing = false; // en cours d'écriture de texte
    this.correcting = false; // en cours de correction

    this.onDraw = this.onDraw.bind(this);
    this.onHandleChangeScroll = this.onHandleChangeScroll.bind(this);
    this.onWheel = this.onWheel.bind(this);
    this.onScrollKeyDown = this.onScrollKeyDown.bind(this);
    this.onDoubleClick = this.onDoubleClick.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onShowContextMenu = this.onShowContextMenu.bind(this);
    this.onApplyCorrection = this.onApplyCorrection.bind(this);
    this.onApplyCorrectionAll = this.onApplyCorrectionAll.bind(this);
    this.onAddWordToDictionary = this.onAddWordToDictionary.bind(this);
    this.onIgnoreWordForCorrection = this.onIgnoreWordForCorrection.bind(this);
    this.onIgnoreSuggestForCorrection =
      this.onIgnoreSuggestForCorrection.bind(this);
    this.onSearchClose = this.onSearchClose.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onPrevPositionSearch = this.onPrevPositionSearch.bind(this);
    this.onNextPositionSearch = this.onNextPositionSearch.bind(this);
    this.onReplaceOne = this.onReplaceOne.bind(this);
    this.onReplaceAll = this.onReplaceAll.bind(this);
    this.onSearchCaseSensitive = this.onSearchCaseSensitive.bind(this);
    this.onSearchWholeWord = this.onSearchWholeWord.bind(this);
    this.onShowSpeakerMenu = this.onShowSpeakerMenu.bind(this);
    this.onSelectSpeaker = this.onSelectSpeaker.bind(this);
    this.onCloseSpeakerMenu = this.onCloseSpeakerMenu.bind(this);
    this.onClosePopup = this.onClosePopup.bind(this);

    this.continue = false;

    this.underSelection = false; // si c'est le texte est sous sélection
    this.wordsToSelect = []; // les mots en cours de sélection
    this.wordsSelected = []; // Les mots sélectionnés
    this.lettersToSelect = []; // Les lettres en cours de sélection

    this.redoActions = []; // Les actions redo
    this.undoActions = []; // les actions undo

    this.wordsToSearch = []; // Les mots à rechercher

    this.prevPositionsCursor = []; // Les dernières positions du curseur alimentés à chaque click

    this.hasEmptyWord = false; // si on a créé un mot vide

    this.loaded = false; // si le canvas est chargé

    this.grammalecte = null;
  }

  async componentDidMount() {
    // Crée un ResizeObserver
    this.createResizeObserver();

    this.initProps();
    
    // chargement des images
    this.cpIcon = new Image();
    this.cpIcon.src = cp;

    this.checkstIcon = new Image();
    this.checkstIcon.src = checkst;

    this.newstIcon = new Image();
    this.newstIcon.src = newst;

    this.tcManualIcon = new Image();
    this.tcManualIcon.src = tcmanual;

    this.addEventListenersInPassive();

    this.continue = true;
    this.loaded = false;

    requestAnimationFrame(this.onDraw); // on lance le dessin du texte

    this.grammalecte = new Grammalecte();
    await this.grammalecte.init();
  }

  createResizeObserver() {
    // on va surveiller automatiquement les changements de taille du foreCanvas......
    const div = document.querySelector('#textDiv'); // Sélectionne la div

    this.resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;

        this.onResize(width, height);
      }
    });

    // Observer les changements de taille de la div du foreCanvas
    this.resizeObserver.observe(div);
  }

  componentDidUpdate(prevProps, prevState) {

    if (prevProps.initialFontSize !== this.props.initialFontSize) {
      this.initOrUpdateFontSize();
      return;
    }

    // si la propriété readonly change, on le met à jour
    if (
      prevProps.readonly !== this.readonly &&
      !this.state.transcription.hasDisplayOriginal
    ) {
      this.readonly = prevProps.readonly;
    }

    if (prevProps.noCursor !== this.props.noCursor) {
      this.noCursor = this.props.noCursor;
    }

    if (prevProps.showPosition !== this.props.showPosition) {
      this.showPosition = this.props.showPosition;
    }

    // si la taille change, on rafraichit le canvas
    if (prevState.font.fontSize !== this.state.font.fontSize) {
      this.onCanvasChange(true);
    }

    if (
     this.props.showSpeakers &&
      (!isEqual(prevProps.speakers, this.props.speakers) ||
        prevProps.speakers.length !== this.props.speakers.length)
    ) {

      if (this.state.identifySpeaker.show) {
        const { speakerId, color } = this.state.identifySpeaker;

        const speaker = this.props.speakers.find((x) => x.id === speakerId);
        if (speaker) {
          // si la couleur du speaker a changé
          const colorSelected = getColorByShortcut(speaker.color)
          if (colorSelected !== color) {
            this.setState({
              identifySpeaker: {
                ...this.state.identifySpeaker,
                color: colorSelected ? colorSelected.hex : '#CCCCCC',
              },
            });
          }
        }
      }

      this.onRefreshCanvas();
    }
  }

  componentWillUnmount() {
    this.resizeObserver.disconnect();
    this.continue = false;
    this.loaded = false;

    this.removeEventListeners();
    this.grammalecte.stop();
  }

  initProps() {
    this.readonly = this.props.readonly;
    this.noCursor = this.props.noCursor;
    this.showPosition = this.props.showPosition;

    if (this.props.initialFontSize) {
      this.initOrUpdateFontSize();
    }
  }

  initOrUpdateFontSize() {
    this.setState({
      font: {
        fontSize: this.props.initialFontSize,
        baseFontSize: 22,
        fontText: 'Arial',
        px: this.props.initialFontSize / 22,
      },
    });
  }

  // ***************************************************************************************
  // addEventListenersInPassive()
  // on ajoute les évenements en passive pour que le navigateur ne puisse pas prendre les actions
  // ***************************************************************************************
  addEventListenersInPassive() {
    const element = document.getElementById('idTranscript');
    if (element) {
      element.addEventListener('wheel', this.onWheel, { passive: false });
    }
  }

  // ***************************************************************************************
  // removeEventListeners()
  // on supprime les évenements passifs lors de la déconnexion du composant
  // ***************************************************************************************
  removeEventListeners() {
    if (!this.loaded) {
      return;
    }

    const element = document.getElementById('idTranscript');
    if (element) {
      element.removeEventListener('wheel', this.onWheel);
    }
  }

  // ***************************************************************************************
  // getOriginalTranscription()
  // Récupération de la transcription originale
  // ***************************************************************************************
  getOriginalTranscription() {
    const script = this.state.transcription.original.script;
    return cloneTranscription(script);
  }
  
// ***************************************************************************************
  // getTranscriptionPtr()
  // Récupération pointeur de la transcription corrigée
  // ***************************************************************************************
  getTranscriptionPtr() {
    return this.script;
  }

  // ***************************************************************************************
  // getTranscription()
  // Récupération de la transcription corrigée
  // ***************************************************************************************
  getTranscription() {
    return cloneTranscription(this.script);
  }

  // ***************************************************************************************
  // getId()
  // Récupération d'id de la transcription corrigée
  // ***************************************************************************************
  getId() {
    return this.state.transcription.corrected.id;
  }

  // ***************************************************************************************
  // setDescription()
  // Met à jour la description de la transcription corrigée
  // ***************************************************************************************
  setDescription(description, lang) {
    this.setState((prevState) => ({
      transcription: {
        ...prevState.transcription,
        description: prevState.transcription.hasDisplayOriginal
          ? prevState.transcription.description
          : description,
        lang: prevState.transcription.hasDisplayOriginal
          ? prevState.transcription.lang
          : lang,
        corrected: {
          ...prevState.transcription.corrected,
          description,
        },
      },
    }));

   /* if (this.grammalecte && this.grammalecte.lang !== lang) {

      this.grammalecte.setLang(lang);
      this.onScriptChecker();
    }*/
  }

  // ***************************************************************************************
  // setOriginalDescription()
  // Met à jour la description de la transcription originale
  // ***************************************************************************************
  setOriginalDescription(description) {
    this.setState((prevState) => ({
      transcription: {
        ...prevState.transcription,
        description: prevState.transcription.hasDisplayOriginal
          ? description
          : prevState.transcription.description,
        original: {
          ...prevState.transcription.original,
          description,
        },
      },
    }));
  }

  // ***************************************************************************************
  // goto()
  // Placer le curseur en fonction du timecode
  // ***************************************************************************************
  goto(timecode, refresh = true) {
    if (!timecode || !this.script) {
      return;
    }


    // prendre le mot le plus proche du timecode
    const getDistance = (word) => {
      if (timecode < word.startTime) {
        return word.startTime - timecode;
      }

      if (timecode > word.endTime) {
        return timecode - word.endTime;
      }

      return 0;
    };

    const closestWord = this.script.reduce((closest, word) =>
      getDistance(word) < getDistance(closest) ? word : closest
    );


    if(!closestWord) {
      return;
    }

    this.currentWordIndex = closestWord.index;
    this.currentLineIndex = closestWord.indexLine;

    this.takeFirstLetter = true;

    if (!this.readonly) {
      this.onMove();
    }

    if (refresh) {
      // mettre le scroll à la bonne position
      this.scrollOffsetLine = this.currentLineIndex;
      this.changeScrollValueState(this.scrollOffsetLine);

      this.onRefreshCanvas();
    }
  }

  // ***************************************************************************************
  // getCurrentWordIndex()
  // retourne l'index du mot où se trouve le curseur
  // ***************************************************************************************
  getCurrentWordIndex() {
    return this.currentWordIndex;
  }

  // ***************************************************************************************
  // replaceWords() remplace des mots par d'autres mots
  // cette fonction supprime des mots entre startIndex et endIndex
  // et les remplace par des nouveaux mots
  // ***************************************************************************************

  replaceWords(startIndex, endIndex, newWords) {
    this.script.splice(startIndex, endIndex - startIndex + 1, ...newWords);

    const nextIndex = startIndex + newWords.length - 1;

    this.currentWordIndex = nextIndex;
    this.currentWord = this.script[nextIndex];
    this.currentLetter = null;

    this.onRefreshCanvas();
  }

  // ***************************************************************************************
  // onRefreshCanvas()
  // on rafraichit le canvas
  // ***************************************************************************************
  onRefreshCanvas(forceRecalculateLines = true) {
    this.forceRecalculateLines = forceRecalculateLines;
    this.forceRedraw = true;
  }

  // ***************************************************************************************
  // onDraw()
  // cette fonction est appelée continuellement pour le dessin du texte
  // ***************************************************************************************
  async onDraw() {
    if (this.foreCanvas && this.foreCanvas.current) {
      if (this.forceRedraw && this.script) {

        // Vérifiez que les dimensions du canvas sont valides
        if (this.backCanvas.width === 0 || this.backCanvas.height === 0) {
          console.warn(
            'Canvas dimensions are invalid (width or height is 0). Redraw.'
          );

          // on va réinitialiser le canvas
          this.resizeObserver.disconnect();
          this.createResizeObserver();

          await wait(200);

          this.onDraw();

          return;
        }

        
        this.speakerAreas = []; // Réinitialiser les zones cliquables du speaker

        // ici on dessine le texte dans le backCanvas
        this.backCtx = this.backCanvas.getContext('2d');
        this.backCtx.fillStyle = '#101010';
        this.backCtx.fillRect(0, 0, this.width, this.height);
        this.backCtx.textBaseline = 'top';
        this.backCtx.font = `${this.state.font.fontSize}px ${this.state.font.fontText}`;

        // dessin du script à la position en cours

        // Départ des coordonnées
        let currentX = 10;
        let currentY = 10;

        if (this.props.speakers && this.props.speakers.length) {
          currentY = 30;
        }

        this.spaceWidth = this.backCtx.measureText(' ').width;
        const metrics = this.backCtx.measureText('I');
        this.lineHeight =
          metrics.actualBoundingBoxAscent +
          metrics.actualBoundingBoxDescent +
          20;

        if (this.state.font.px < 1) {
          this.lineHeight =
            metrics.actualBoundingBoxAscent +
            metrics.actualBoundingBoxDescent +
            20 * this.state.font.px;
        }

        // On recalcule le nombre de lignes pour le scroll
        this.nbVisibleLines = Math.floor(this.height / this.lineHeight);

        // Tant que ce n'est pas chargé, on initalise les index et indexLines;
        if (!this.loaded || this.forceRecalculateLines) {
          this.recalculateIndexes();
          this.recalculateLines();

          if (!this.loaded) {
            this.onScriptChecker();
          }
        }

        let indexWord = 0;
        let indexLetter = 0;

        const startWordIndex = this.script.findIndex(
          (x) => x.indexLine === this.scrollOffsetLine
        );
        if (startWordIndex !== -1) {
          indexWord = startWordIndex;
        }

        let index = 0;
        let prevSpeakerId = 0;

        while (currentY < this.height && indexWord < this.script.length) {
          const currentWord = this.script[indexWord];

          const metricsWord = this.backCtx.measureText(currentWord.text);

          currentWord.width = metricsWord.width + this.spaceWidth;
          currentWord.height =
            metricsWord.actualBoundingBoxAscent +
            metricsWord.actualBoundingBoxDescent;
          
          let newst = false;
          // on doit mettre à la ligne si on marque le mot "newst"
          if (currentWord.markWord) {
            const markWords = findMarkWords(currentWord.markWord);

            if (markWords.find((x) => x.key === 'NEWST') && index !== 0) {
              newst = true;
            }
          }

          if (currentWord.newline && indexLetter !== 0) {
            currentY += this.lineHeight * 1.5;
            currentX = this.metricX;
            indexLetter = 0;
          } else {
            if (currentX + currentWord.width > this.width - this.metricX || newst) {
              currentY += this.lineHeight;
              currentX = this.metricX;
              indexLetter = 0;
            }
          }

          currentWord.x = currentX;
          currentWord.y = currentY;
          currentWord.startX = currentX;
          currentWord.endX = currentX + currentWord.width;
          currentWord.startY = currentY - this.metricY;
          currentWord.endY = currentY + this.lineHeight;

          indexLetter = this.createLettersForWord(
            currentWord,
            currentX,
            currentY,
            indexLetter
          );

          // on stabilote
          if (currentWord.stabilo && currentWord.stabilo > 0 && currentWord.stabiloColor) 
          {
              const prevWord = this.script[indexWord - 1];
            const nextWord = this.script[indexWord + 1];
            const isFirstSelection =
              !prevWord ||
              !(prevWord.stabilo && prevWord.stabilo > 0) ||
              currentWord.newline;
            const isLastSelection =
              !(nextWord && nextWord.stabilo && nextWord.stabilo > 0) ||
              nextWord.newline;

                        
            this.drawSelectionWordStabilo(
              this.backCtx,
              currentWord,
              isFirstSelection,
              isLastSelection,
              currentWord.stabiloColor
            );
            
          }

           // on stabilote
          if (
            this.state.identifySpeaker.show &&
            this.state.identifySpeaker.speakerId === currentWord.speakerId
          ) {
            const prevWord = this.script[indexWord - 1];
            const nextWord = this.script[indexWord + 1];
            const isFirstSelection = !prevWord || currentWord.newline;
            const isLastSelection = !nextWord || nextWord.newline;

            this.drawSelectionWord(
              this.backCtx,
              currentWord,
              isFirstSelection,
              isLastSelection,
              this.state.identifySpeaker.color
            );
          }

          if (
            this.state.search.showSearch &&
            this.wordsToSearch.find(
              (x) =>
                (x.indexLine === currentWord.indexLine ||
                  x.indexLine === currentWord.parentIndexLine) &&
                x.words.includes(currentWord)
            )
          ) {
            this.drawSearchWord(this.backCtx, currentWord);
          }

         
          if (this.underSelection) {
              const indexSelection = this.wordsToSelect.findIndex(
              (x) => x.index === currentWord.index
            );
            if (this.wordsToSelect.length && indexSelection !== -1) {
              const isFirstSelection = indexSelection === 0;
              const isLastSelection =
                indexSelection === this.wordsToSelect.length - 1;
              this.drawSelectionWord(
                this.backCtx,
                currentWord,
                isFirstSelection,
                isLastSelection
              );
            }

            if (this.lettersToSelect.length) {
              const letters = this.lettersToSelect.filter(
                (x) => x.indexWord === currentWord.index
              );

              if (letters.length) {
                letters.forEach((l) =>
                  this.drawSelectionLetter(this.backCtx, l)
                );
              }
            }
          }

          if (currentWord.index === 0 || currentWord.newline) {
            const y = currentY - (this.lineHeight / 2);

            this.drawSpeaker(this.backCtx, currentWord.speakerId, y, currentWord.index, prevSpeakerId);

            prevSpeakerId = currentWord.speakerId;
          }

          this.backCtx.font = `${this.state.font.fontSize}px ${this.state.font.fontText}`;
          this.backCtx.fillStyle =
            currentWord.submitted === true ? 'gray'
             : this.state.identifySpeaker.show &&
                  this.state.identifySpeaker.speakerId === currentWord.speakerId
                ? 'black'
              : currentWord.color;
          this.backCtx.fillText(currentWord.text, currentX, currentY);

          if (!this.noCursor) {
            if (currentWord.markWord) {
              this.drawMarkWords(this.backCtx, currentWord);
            }

            if (currentWord.suggests?.length) {
              this.drawSuggestErrors(this.backCtx, currentWord);
            }

            if (
              currentWord.cpbefore === true ||
              currentWord.cpafter === true ||
              currentWord.cpinside === true
            ) {
              this.drawCp(this.backCtx, currentWord);
            }
          }

          currentX += currentWord.width;
          indexWord++;
          index++;
        }

        this.forceRedraw = false;

        if (!this.loaded) {
          this.loaded = true;
        }
      }
      this.foreCtx = this.foreCanvas.current.getContext('2d');
      this.foreCtx.drawImage(this.backCanvas, 0, 0);

      // Créer le curseur
      if (this.script) {
        this.createCursor();
      }

      if (this.continue === true) {
        requestAnimationFrame(this.onDraw); // on lance le dessin du texte
      }
    }
  }

  // ***************************************************************************************
  // recalculateIndexes() permet de recalculer les index
  // ***************************************************************************************
  recalculateIndexes() {
    if (!this.script || !this.script.length) {
      return;
    }

    this.script.forEach((word, index) => (word.index = index));
    this.setState({
      totalWords: this.script.length,
    });
  }

  // ***************************************************************************************
  // recalculateLines() permet de recalculer les lignes
  // ***************************************************************************************
  recalculateLines() {
    if (!this.script || !this.script.length) {
      this.setState({
        currentPositionLine: 0,
        currentPositionWord: 0,
        totalLines: 0,
        maxScrollValue: 0,
      });
      return;
    }

    let indexLine = 0;
    let x = 10;
    let parentIndexLine = 0;

    for (let i = 0; i < this.script.length; i++) {
      const word = this.script[i];

      const metricsWord = this.backCtx.measureText(word.text);

      const width = metricsWord.width + this.spaceWidth;

      let newst = false;
      // on doit mettre à la ligne si on marque le mot "newst"
      if (word.markWord) {
        const markWords = findMarkWords(word.markWord);

        if (markWords.find((x) => x.key === 'NEWST')) {
          newst = true;
        }
      }

      if (i !== 0 && word.newline) {
        indexLine++;
        parentIndexLine = indexLine;
        x = this.metricX;
      } else {
        if (this.width !== 0 && x + width > this.width - this.metricX || newst) {
          indexLine++;
          x = this.metricX;
        }
      }

      x += width;

      word.indexLine = indexLine;

      if (parentIndexLine !== indexLine) {
        word.parentIndexLine = parentIndexLine;
      } else {
        word.parentIndexLine = undefined;
      }

      // on clear les coordonnées parce qu'ils seront calculés
      word.x = 0;
      word.y = 0;
      word.startX = 0;
      word.endX = 0;
      word.startY = 0;
      word.endY = 0;
    }

    const totalLines = indexLine + 1;
    const maxScrollValue = totalLines - this.nbVisibleLines + (Math.floor(this.nbVisibleLines / 2));

    // Ajuster scrollOffsetLine s'il dépasse le nombre total de lignes après recalcul
    if (this.scrollOffsetLine >= totalLines) {
      this.scrollOffsetLine = Math.max(0, maxScrollValue);
      this.changeScrollValueState(this.scrollOffsetLine);
    }

    this.setState({
      totalLines,
      maxScrollValue,
    });
  }

  canDeselect(key) {
    const keys = [
      'SELECTRIGHT',
      'SELECTLEFT',
      'SELECTUP',
      'SELECTDOWN',
      'UP',
      'DOWN',
      'LEFT',
      'RIGHT',
      'COPY',
      'CUT',
      'PASTE',
      'BACKSPACE',
      'ENTER',
      'DELETE',
      'DELETEWORD',
      'DELETELINE',
      'BLUE',
      'GREEN',
      'CYAN',
      'RED',
      'MAGENTA',
      'YELLOW',
      'WHITE',
      'SELECTA',
      'TAB',
      'ADDQUOTES',
      'GROUPWORDSWITHOUTSPACE',
      'GROUPBYUNSECABLESPACEWITHNEXTWORD',
      'GROUPBYUNSECABLESPACEWITHPREVIOUSWORD',
      'DELETEWORDSUNTIL',
      'HYPHENATETWOWORDS',
      'ADDTWOAPOSTROPHES',
      'SELECTLETTERBYLETTERONRIGHT',
      'SELECTLETTERBYLETTERONLEFT',
    ];

    return this.underSelection && !keys.includes(key);
  }

  // ***************************************************************************************
  // cannotExecuteShortcutInReadonly()
  // si la transcription est en mode readonly alors on ne doit pas éxécuter ces actions
  // ***************************************************************************************
  cannotExecuteShortcutInReadonly(key) {
    const keys = [
      'BACKSPACE',
      'ENTER',
      'DELETE',
      'CHECKWORD',
      'NEWST',
      'TCIN',
      'TCOUT',
      'UNSECABLE',
      'CUT',
      'PASTE',
      'UNDO',
      'REDO',
      'REPLACE',
      'BLUE',
      'GREEN',
      'CYAN',
      'RED',
      'MAGENTA',
      'YELLOW',
      'WHITE',
      'TAB',
      'WORDCHECKER',
      'DELETEWORD',
      'DELETELINE',
      'ADDHYPHEN',
      'GROUPWORDSWITHOUTSPACE',
      'GROUPBYUNSECABLESPACEWITHNEXTWORD',
      'GROUPBYUNSECABLESPACEWITHPREVIOUSWORD',
      'CONVERSIONTOINITIAL',
      'CONVERSIONTOINITIALWITHOUTSPACE',
      'UPPERCASEORLOWERCASEONFIRSTLETTER',
      'UPPERCASEORLOWERCASEONSECONDLETTER',
      'UPPERCASEORLOWERCASEWITHDASH',
      'UPPERCASEORLOWERCASEWITHAPOSTROPHEORPERIOD',
      'UPPERCASEONWORD',
      'LOWERCASEONWORD',
      'UPPERCASEORLOWERCASEONSENTENCE',
      'RETURNTOLINEWITHHYPHEN',
      'ADDPERIOD',
      'DELETEUNSECABLE',
      'ADDPERIODANDNEWLINE',
      'ADDQUOTES',
      'ADDONEAPOSTROPHE',
      'ADDTWOAPOSTROPHES',
      'ADDORREMOVESLETTER',
      'ADDORREMOVENTLETTER',
      'INVERTPERIODEANDCOMMA',
      'INVERTA',
      'HYPHENATETWOWORDS',
      'REPLACEHYPHENWITHSPACE',
      'REPLACEHYPHENWITHUNSECABLESPACE',
      'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_C',
      'ADDORREMOVEAPOSTROPHETOLETTER_C',
      'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_D',
      'ADDORREMOVEAPOSTROPHETOLETTER_D',
      'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_J',
      'ADDORREMOVEAPOSTROPHETOLETTER_J',
      'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_L',
      'ADDORREMOVEAPOSTROPHETOLETTER_L',
      'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_M',
      'ADDORREMOVEAPOSTROPHETOLETTER_M',
      'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_N',
      'ADDORREMOVEAPOSTROPHETOLETTER_N',
      'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_Q',
      'ADDORREMOVEAPOSTROPHETOLETTER_Q',
      'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_S',
      'ADDORREMOVEAPOSTROPHETOLETTER_S',
      'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_T',
      'ADDORREMOVEAPOSTROPHETOLETTER_T',
      'REPLACE_E',
      'REPLACE_Z',
      'REPLACE_R',
      'ADDORREMOVELETOWORD',
      'SUBMITWORD',
      'SUBMITSENTENCE',
      'SUBMITUNTILPUNCTUATION',
      'CANCELSUBMITWORDS',
    ];

    return keys.includes(key);
  }

  // ***************************************************************************************
  // processShortcut() appelée par l'application lors de l'appui sur une touche du clavier
  // correspondant à un raccourci.
  // ***************************************************************************************
  processShortcut(key, event) {
    // voir ../utils.js pour ajouter / supprimer les raccourcis

    if (this.noCursor) {
      return;
    }

    if (!this.script || !this.script.length) {
      if (key !== 'UNDO' && key !== 'REDO') {
        return;
      }
    }

    if (this.state.speakerMenu.display) {
      this.onCloseSpeakerMenu();
      return;
    }

    if (this.state.contextMenu.display) {
      this.onCloseContextMenu();
      return;
    }

    // cale la video au sous titre correcspondant
    if (key === "SETTIMECODEOUTFROMCURRENTSUBTITLETOVIDEO")
    {
      const currentWord = this.script[this.currentWordIndex];

      if (!currentWord) {
        return;
      }
      
      if ("ststarttime" in currentWord)
      {
        this.props.onMove(currentWord.ststarttime, true);
      }    
    }


    // cale la vidéo à partir du timecode du mot courant
    if ( key === 'SETTIMECODEINFROMCURRENTSUBTITLETOVIDEO' ) {
      const currentWord = this.script[this.currentWordIndex];

      if (!currentWord) {
        return;
      }

      
      this.props.onMove(currentWord.startTime, true);
      return;
    }


    // si le panneau de recherche est affiché, alors le keydown doit y être appliqué
    if (
      this.state.search.showSearch &&
      event &&
      event.target.id !== 'textDiv'
    ) {
      if (this.searchRef && this.searchRef.current) {
        this.searchRef.current.onKeyDown(event);
        return;
      }
    }

    // si la transcription est en mode readonly alors on ne doit pas éxécuter ces actions
    // également si le mot en cours a été validé
    if (
      (this.readonly || (this.currentWord && this.currentWord.submitted)) &&
      this.cannotExecuteShortcutInReadonly(key)
    ) {
      return;
    }

    // si on a un mot vide, on le supprime et on refait l'action
    if (this.hasEmptyWord && key !== 'UNDO' && key !== 'REDO') {
      this.removeEmptyWord(key).then(() => this.processShortcut(key));
      return;
    }

    // on désélectionne les mots
    if (this.canDeselect(key)) {
      this.underSelection = false;
      this.onChange(this.currentWord.startTime, this.currentWord.index, false);
    }

    switch (key) {
      case 'SAVE':
        this.onSave();
        break;

      case 'UP':
      case 'DOWN':
      case 'LEFT':
      case 'RIGHT':
        this.onMoveCursorLetterByLetter(key);
        break;

      case 'SELECTLEFT':
      case 'SELECTRIGHT':
      case 'SELECTUP':
      case 'SELECTDOWN':
        this.onSelect(key);
        break;
      
      case 'SELECTLETTERBYLETTERONRIGHT':
      case 'SELECTLETTERBYLETTERONLEFT':
        this.onSelectLetterByLetter(key);
        break;

      case 'STARTWORD':
      case 'ENDWORD':
        this.onGoToStartOrEndOfWord(key);
        break;

      case 'HOME':
      case 'END':
        this.onGoToHomeOrEnd(key);
        break;

      case 'PGUP':
      case 'PGDOWN':
        this.onGoToPageUpOrDown(key);
        break;

      case 'BACKSPACE':

        if (this.currentWord?.rtl) {
          this.onBackspaceLeftToRight();
          return;
        }
        
        this.onBackspace();
        break;

      case 'ENTER':
        this.onEnter();
        break;

      case 'DELETE':

        if (this.currentWord?.rtl) {
          this.onDeleteLeftToRight();
          return;
        }
        
        this.onDelete();
        break;

      case 'DELETEWORD':
        this.onDeleteWord();
        break;

      case 'DELETELINE':
        this.onDeleteLine();
        break;

      case 'DELETEWORDSUNTIL':
        this.onDeleteWordsUntil();
        break;

      case 'CHECKWORD':
      case 'NEWST':
      case 'TCIN':
      case 'TCOUT':
        this.onMarkWord(key);
        break;

      case 'PREVIOUSWORD':
      case 'NEXTWORD':
        this.onMoveWordByWord(key === 'PREVIOUSWORD');
        break;

      case 'UNSECABLE':
        this.addChar(String.fromCharCode(0xa0));
        break;

      case 'DELETEUNSECABLE':
        this.removeUnsecableSpace();
        break;

      case 'COPY':
        this.onCopy();
        break;

      case 'PASTE':
        this.onPaste();
        break;

      case 'CUT':
        this.onCut();
        break;

      case 'UNDO':
      case 'REDO':
        this.onUndoOrRedo(key);
        break;

      case 'SEARCH':
        if (this.state.search.showSearch) {
          this.onSearchClose();
        } else {
          this.setState({
            search: {
              ...this.state.search,
              showSearch: true,
              showReplace: false,
            },
          });
        }
        break;

      case 'REPLACE':
        if (this.state.search.showReplace) {
          this.onSearchClose();
        } else {
          this.setState({
            search: {
              ...this.state.search,
              showSearch: true,
              showReplace: true,
            },
          });
        }
        break;

      case 'BLUE':
      case 'GREEN':
      case 'CYAN':
      case 'RED':
      case 'MAGENTA':
      case 'YELLOW':
      case 'WHITE':
        this.onSetColor(key);
        break;

      case 'LOCK':
        if (this.lockScroll) {
          this.goto(this.currentWord.startTime);
        }

        this.lockScroll = !this.lockScroll;

        break;

      case 'PREVIOUSMATCH':
        this.onPrevPositionSearch();
        break;
      case 'NEXTMATCH':
        this.onNextPositionSearch();
        break;

      case 'PREVIOUSPOSITION':
        this.onPreviousPositionCursor();
        break;

      case 'SELECTA':
        this.onSelectWithCtrlA();
        break;

      case 'STARTSENTENCE':
      case 'ENDSENTENCE':
        this.onGoToSentence(key);
        break;

      case 'SELECTUPSENTENCE':
      case 'SELECTDOWNSENTENCE':
        this.onSelectSentence(key);
        break;

      case 'NOZOOM':
      case 'ZOOMIN':
      case 'ZOOMOUT':
        this.onZoom(key);
        break;

      case 'REFRESH':
        this.clearCoordinates();
        this.onRefreshCanvas();
        break;

      case 'TAB':
        this.onTab();
        break;

      case 'CHANGETRANSCRIPTION':
        this.onChangeTranscription();
        break;

      case 'WORDCHECKER':
        this.onScriptChecker();
        break;
      case 'GOTOWORDINERROR':
        this.onGoToWordInError();
        break;

      case 'ADDHYPHEN':
        this.addHyphen();
        break;

      case 'ADDPERIOD':
      case 'ADDPERIODANDNEWLINE':
        this.addPeriod(key === 'ADDPERIODANDNEWLINE');
        break;

      case 'GROUPBYUNSECABLESPACEWITHNEXTWORD':
      case 'GROUPBYUNSECABLESPACEWITHPREVIOUSWORD':
        this.groupWordsByUnsecableSpace(
          key === 'GROUPBYUNSECABLESPACEWITHNEXTWORD'
        );
        break;

      case 'GROUPWORDSWITHOUTSPACE':
        this.groupWordsWithoutSpace();
        break;

      case 'CONVERSIONTOINITIAL':
      case 'CONVERSIONTOINITIALWITHOUTSPACE':
        this.onConversionToInitial(key === 'CONVERSIONTOINITIAL');
        break;

      case 'UPPERCASEORLOWERCASEONFIRSTLETTER':
      case 'UPPERCASEORLOWERCASEONSECONDLETTER':
      case 'UPPERCASEORLOWERCASEWITHDASH':
      case 'UPPERCASEONWORD':
      case 'LOWERCASEONWORD':
      case 'UPPERCASEORLOWERCASEONSENTENCE':
      case 'UPPERCASEORLOWERCASEWITHAPOSTROPHEORPERIOD':
        this.onUpperOrLowerCase(key);
        break;

      case 'RETURNTOLINEWITHHYPHEN':
        this.onReturnToLineWithHypen();
        break;

      case 'ADDQUOTES':
        this.addQuotes();
        break;

      case 'ADDTWOAPOSTROPHES':
      case 'ADDONEAPOSTROPHE':
        this.addApostrophes(key === 'ADDONEAPOSTROPHE');
        break;

      case 'ADDORREMOVESLETTER':
      case 'ADDORREMOVENTLETTER':
        this.addOrRemoveLetter(key);
        break;

      case 'INVERTPERIODEANDCOMMA':
        this.invertPeriodAndComma();
        break;

      case 'INVERTA':
        this.invertALetter();
        break;

      case 'HYPHENATETWOWORDS':
        this.hyphenateTwoWords();
        break;

      case 'REPLACEHYPHENWITHSPACE':
      case 'REPLACEHYPHENWITHUNSECABLESPACE':
        this.replaceHyphenate(key === 'REPLACEHYPHENWITHUNSECABLESPACE');
        break;

      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_C':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_D':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_J':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_L':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_M':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_N':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_Q':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_S':
      case 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_T':
        this.addOrRemoveLetterWithApostrophe(key);
        break;

      case 'ADDORREMOVEAPOSTROPHETOLETTER_C':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_D':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_J':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_L':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_M':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_N':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_Q':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_S':
      case 'ADDORREMOVEAPOSTROPHETOLETTER_T':
        this.addOrRemoveApostropheToLetter(key);
        break;

      case 'REPLACE_E':
      case 'REPLACE_Z':
      case 'REPLACE_R':
      case 'REPLACE_T':
        this.replaceLetter(key);
        break;

      case 'ADDORREMOVELETOWORD':
        this.addOrRemoveLeToWord();
        break;

      case 'SUBMITWORD':
        this.onSubmitWord();
        break;

      case 'SUBMITSENTENCE':
      case 'SUBMITUNTILPUNCTUATION':
        this.onSubmitSentence(key === 'SUBMITUNTILPUNCTUATION');
        break;

      case 'CANCELSUBMITWORDS':
        this.onCancelSubmittedWords();
        break;

      case 'GOTONEXTDIALOGUE':
      case 'GOTOPREVIOUSDIALOGUE':
        this.onGoToSpeakerDialogue(key);
        break;


      default:
        return false;
    }

    return true;
  }

  // ***************************************************************************************
  // drawMarkWords()
  // permet de marquer les mots dans le canvas
  // ***************************************************************************************
  drawMarkWords(ctx, currentWord) {
    const markWords = findMarkWords(currentWord.markWord);

    let iconX = currentWord.x;
    markWords.forEach((markWord) => {
      let icon = null;

      switch (markWord.key) {
        case 'CHECKWORD':
          icon = this.checkstIcon;
          break;

        case 'NEWST':
          icon = this.newstIcon;
          break;
        
        case 'TCIN':
        case 'TCOUT':
          icon = this.tcManualIcon;
          if (markWord.key === 'TCOUT') {
            const lastLetter = last(currentWord.letters);
            iconX = lastLetter.x - lastLetter.width;
          }
          break;

        default:
          throw Error('icon not implemented');
      }

      const iconY =
        currentWord.y +
        (this.state.font.px < 1
          ? this.metricY + 5 * this.state.font.px
          : this.metricY + 12 * this.state.font.px);

      const widthHeight = 12 * this.state.font.px;

      ctx.drawImage(icon, iconX, iconY, widthHeight, widthHeight);

      iconX += widthHeight;
    });
  }

  // ***************************************************************************************
  // drawSuggestErrors()
  // permet de marquer les mots en erreur
  // ***************************************************************************************
  drawSuggestErrors(ctx, word) {
    if (!word.suggests || !word.suggests.length) {
      return;
    }

    word.suggests.forEach(() => {
      const startX = word.startX;
      let endX = word.endX - this.spaceWidth;
      let endY = word.endY - 15;

      if (this.state.font.px < 1) {
        endY = word.endY - 8;
      }

      ctx.beginPath();
      ctx.moveTo(startX, endY);
      ctx.lineTo(endX, endY);

      ctx.strokeStyle = 'red';
      ctx.lineWidth = 2;
      ctx.stroke();
    });
  }

  drawCp(ctx, word) {
    const iconY =
      word.y +
      (this.state.font.px < 1
        ? this.metricY + 5 * this.state.font.px
        : this.metricY + 12 * this.state.font.px);

    const widthHeight = 12 * this.state.font.px;

    if (word.cpbefore === true) {
      const iconX = word.x - this.spaceWidth / 2 - widthHeight / 2;
      ctx.drawImage(this.cpIcon, iconX, iconY, widthHeight, widthHeight);
    }
    if (word.cpafter === true) {
      const iconX = word.x + word.width - widthHeight / 2;
      ctx.drawImage(this.cpIcon, iconX, iconY, widthHeight, widthHeight);
    }

    if (word.cpinside === true) {
      const iconX = word.x + word.width / 2 - this.spaceWidth / 2 - widthHeight / 2;
      ctx.drawImage(this.cpIcon, iconX, iconY, widthHeight, widthHeight);
    }    
  }

  // ***************************************************************************************
  // drawSpeaker()
  // permet d'afficher le speaker
  // ***************************************************************************************
  drawSpeaker(ctx, speakerId, y, wordIndex, prevSpeakerId) {
    if (!this.props.showSpeakers) {
      return;
    }

    const speaker = this.props.speakers
      ? this.props.speakers.find((x) => x.id === speakerId)
      : null;

    const name = speakerId !== prevSpeakerId ? this.getSpeakerName(speaker) : '';
    const color =
      speaker && speaker.color
        ? getColorByShortcut(speaker.color).hex
        : '#CCCCCC';

    ctx.fillStyle = color;

    const fontSize = 12 * this.state.font.px;

    ctx.font = `${fontSize}px ${this.state.font.fontText}`;
    ctx.fillText(name, 10, y);

    if (this.readonly) {
      return;
    }

    const metrics = ctx.measureText(name);

    const width = name ? metrics.width : this.width;

    const height =
      name && name !== '...'
        ? metrics.actualBoundingBoxAscent +
          metrics.actualBoundingBoxDescent +
          15
        : 27;

    const callbackOpen = () => {
      // Nettoyer la zone avant de redessiner
      ctx.fillStyle = '#101010';
      ctx.fillRect(10, y, metrics.width, height - 15);

      ctx.fillStyle = '#FF8282';
      ctx.font = `${fontSize}px ${this.state.font.fontText}`;
      ctx.fillText(name, 10, y);
    };

    const callbackClose = (speakerId) => {
      
      if (!speakerId || speakerId === prevSpeakerId){
        return;
      }

      const speakerSelected = speakerId
        ? this.props.speakers.find((x) => x.id === speakerId)
        : speaker;

      // Nettoyer la zone avant de redessiner
      ctx.fillStyle = '#101010';
      ctx.fillRect(10, y, metrics.width, height - 15);

      const colorSelected =
        speakerSelected && speakerSelected.color
          ? getColorByShortcut(speakerSelected.color).hex
          : '#CCCCCC';

      ctx.fillStyle = colorSelected;
      ctx.font = `${fontSize}px ${this.state.font.fontText}`;
      ctx.fillText(this.getSpeakerName(speakerSelected), 10, y);
    };

    this.speakerAreas.push({
      x: 10,
      y: y - 15,
      width,
      height,
      speakerId,
      wordIndex,
      callbackOpen,
      callbackClose,
      sameSpeaker: speakerId === prevSpeakerId,
    });
  }

  getSpeakerName(speaker) {
    if (!speaker) {
      return '...';
    }

    const names = [];

    if (speaker.firstname) {
      names.push(speaker.firstname);
    }

    if (speaker.name) {
      names.push(speaker.name);
    }

    if (speaker.job) {
      names.push(speaker.job);
    }

    if (speaker.gender) {
      names.push(`(${speaker.gender})`);
    }

    const name = names.join(' ');

    return name;
  }

  // ***************************************************************************************
  // createLettersForWord()
  // permet de créer un tableau de lettres pour un mot afin de définir ses coordonnées X et Y
  // ***************************************************************************************
  createLettersForWord(currentWord, currentX, currentY, indexLetter) {
    const letters = [];
    const text = currentWord.text;

    if (text.length === 0) {
      indexLetter++;
      currentWord.letters = letters;

      return indexLetter;
    }

    for (let i = 0; i < text.length; i++) {
      const char = text.charAt(i);

      const metricsLetter = this.backCtx.measureText(char);

      const letter = {
        index: i,
        letter: char,
        width: metricsLetter.width,
        x: currentX,
        y: currentY,
        indexLetter: indexLetter,
        indexWord: currentWord.index,
        lastChar: false,
      };

      if (i !== 0) {
        const lastLetter = letters[i - 1];
        letter.x = lastLetter.width + lastLetter.x;
      }

      letters.push(letter);

      indexLetter++;
    }

    currentWord.letters = letters;

    const space = {
      letter: ' ',
      width: this.spaceWidth,
      indexLetter: indexLetter,
      lastChar: false,
    };

    if (letters.length === 0) {
      space.x = this.metricX;
    } else {
      const lastLetterOfWord = letters[letters.length - 1];
      space.x = lastLetterOfWord.width + lastLetterOfWord.x;
    }

    space.y = currentY;
    space.indexWord = currentWord.index;
    space.index = letters.length;

    const nextWord = this.script[currentWord.index + 1];
    if (nextWord === undefined || nextWord.newline) {
      space.lastChar = true;
    }

    letters.push(space);
    indexLetter++;

    return indexLetter;
  }

  // ***************************************************************************************
  // createCursor()
  // permet de placer le curseur sur la bonne ligne, le bon mot et le bon caractère
  // et de dessiner le rectangle autour du mot
  // ***************************************************************************************
  createCursor() {
    const height =
      this.state.font.px < 1
        ? this.lineHeight - 6 * this.state.font.px
        : this.lineHeight - 6;

    if (!this.script || !this.script.length) {
      const startY =
        this.state.font.px < 1
          ? this.metricY - 5 * this.state.font.px
          : this.metricY - 5;

      this.showCursor(this.metricX, startY, height);

      return;
    }

    this.currentWord = this.script[this.currentWordIndex];

    if (!this.currentWord || !this.currentWord.letters) {
      // throw new Error('currentWord');
      return;
    }

    // Si le scroll est locké et que je scrolle, je ne dois pas afficher le curseur
    if (this.lockScroll && this.scrolling) {
      return;
    }

    const startY =
    this.state.font.px < 1
      ? this.currentWord.y - 5 * this.state.font.px
      : this.currentWord.y - 5; // Coordonnée Y de départ

    // On est en mode readonly mais on met l'encadré sur le mot sans le curseur
    if (this.readonly && this.showPosition) {
      // Dessiner un rectangle autour du mot
      this.drawRectangleWord(startY, height);

      // Redessiner le mot
      this.drawWord(this.foreCtx, this.currentWord);
    }

    // si le mot est déjà validé, on n'affiche pas le curseur
    // ou la valeur noCursor est à true, on n'affiche pas le curseur
    if (this.currentWord.submitted || this.noCursor) {
      return;
    }

    // mettre le scroll à la bonne position et recalculer les coordonnées
    if (
      !this.underSelection &&
      this.currentWord.x === 0 &&
      this.currentWord.y === 0
    ) {
      this.scrollOffsetLine = this.currentWord.indexLine;
      this.scrollTo(this.scrollOffsetLine);
      return;
    }

    this.setState({
      currentTime: this.currentWord.startTime,
      currentPositionLine: this.currentWord.indexLine + 1,
      currentPositionWord: this.currentWord.index + 1,
    });

    let x = 0; // Coordonnée X de la ligne

    // Définir la coordonnée x
    if (this.currentWord.letters.length === 0) {
      x = this.currentWord.x;
    } else {
      this.currentLetter = this.currentWord.letters.find(
        (x) => x.indexLetter === this.currentLetterIndex
      );

      // Quoiqu'il arrive on prend toujours la dernière lettre du mot pour mettre le curseur à la fin du mot
      if (this.currentLetter === undefined) {
        this.currentLetter = this.takeFirstLetter
          ? first(this.currentWord.letters)
          : last(this.currentWord.letters);
        this.currentLetterIndex = this.currentLetter.indexLetter;

        if (this.takeFirstLetter) {
          this.takeFirstLetter = false;
        }
      }

      x = this.currentLetter.x;
    }

    // Si c'est en cours de déplacement, afficher juste le curseur
    if (this.moving) {
      this.drawCursor(x, startY, height, '#CE8C87');
      return;
    }

    if (this.underSelection) {
      if (
        (this.currentWord.x === 0 && this.currentWord.y === 0) ||
        this.currentWord.y === this.metricY
      ) {
        return;
      }

      if (this.wordsToSelect.length) {
        if (!this.wordsToSelect.includes(this.currentWord)) {
          return;
        }

        this.drawSelectionWord(this.foreCtx, this.currentWord);
      }

      if (this.lettersToSelect.length) {
        if (!this.lettersToSelect.includes(this.currentLetter)) {
          return;
        }

        this.drawSelectionLetter(this.foreCtx, this.currentLetter);
      }

      // Redessiner le mot
      this.drawWord(this.foreCtx, this.currentWord);

      return;
    }

    // Dessiner un rectangle autour du mot
    this.drawRectangleWord(startY, height);

     // on stabilote
  /*  if (this.currentWord.stabilo && this.currentWord.stabilo > 0 && this.currentWord.stabiloColor) {
      this.drawSelectionWord(this.foreCtx, this.currentWord, true, true, this.currentWord.stabiloColor);
    }*/

    // Dessiner un rectangle sur les lettres si la recherche matche
    if (
      this.state.search.showSearch &&
      this.wordsToSearch.length &&
      this.wordsToSearch.find(
        (x) =>
           (x.indexLine === this.currentWord.indexLine ||
              x.indexLine === this.currentWord.parentIndexLine) &&
          x.words.includes(this.currentWord)
      )
    ) {
      // Si on est en mode sélection de la recherche
      if (this.state.search.showSelection) {
        this.drawSearchWord(this.foreCtx, this.currentWord, '#3E79BC');
        this.drawWord(this.foreCtx, this.currentWord);
        return;
      }

      this.drawSearchWord(this.foreCtx, this.currentWord);
    }

    // Redessiner le mot
    this.drawWord(this.foreCtx, this.currentWord);

    // Dessiner le markword
    if (this.currentWord.markWord) {
      this.drawMarkWords(this.foreCtx, this.currentWord);
    }

    // Dessiner le mot en erreur
    if (this.currentWord.suggests?.length) {
      this.drawSuggestErrors(this.foreCtx, this.currentWord);
    }

    this.showCursor(x, startY, height);
  }

  // ***************************************************************************************
  // showCursor() permet d'afficher le curseur en continue (clignotant) ou non
  // ***************************************************************************************
  showCursor(x, startY, height) {
    if (this.showCptCurs) {
      // Dessiner le curseur
      // En fonction du showCptCurs, on peut afficher le curseur de texte clignotant ou non
      this.cptCurs++;
      if (this.cptCurs < 50) {
        this.drawCursor(x, startY, height);
      } else if (this.cptCurs > 100) this.cptCurs = 0;
    } else {
      this.drawCursor(x, startY, height);
    }
  }

  // ***************************************************************************************
  // drawSelectionWord()
  // permet de dessiner la sélection des mots ou on stabilote
  // ***************************************************************************************
  drawSelectionWordStabilo(
    ctx,
    word,
    isFirstSelection = true,
    isLastSelection = true,
    color
  )
  {
      let unit = 6;

      if (this.state.font.px < 1) {
        unit = unit * this.state.font.px;
      }

      var z0 = 2;
      var z1 = 2;
      if (isFirstSelection) z0=3;
      if (isLastSelection) z1=3;


      const rect = {
        x: word.x - z0,
        y: word.y - unit,
        width: word.width + z1,
        height: this.lineHeight - unit,
    };
      drawStabilo(ctx, color, rect)
  }

  drawSelectionWord(
    ctx,
    word,
    isFirstSelection = true,
    isLastSelection = true,
    color = '#595959'
  ) {



    let unit = 6;

    if (this.state.font.px < 1) {
      unit = unit * this.state.font.px;
    }

    const rect = {
      x: word.x - 1,
      y: word.y - unit,
      width: word.width + 0.1,
      height: this.lineHeight - unit,
    };

    if (isLastSelection) {
      rect.width -= this.spaceWidth - 1;
    }

    const radius = 3;

    // Couleur de remplissage du rectangle
    ctx.fillStyle = color;

    ctx.beginPath();
  
    // Ajouter les coins arrondis en fonction de la sélection
    if (isFirstSelection && isLastSelection) {
      ctx.roundRect(rect.x, rect.y, rect.width, rect.height, [radius]);
    } else if (isFirstSelection) {
      ctx.roundRect(rect.x, rect.y, rect.width, rect.height, [
        radius,
        0,
        0,
        radius,
      ]);
    } else if (isLastSelection) {
      ctx.roundRect(rect.x, rect.y, rect.width, rect.height, [
        0,
        radius,
        radius,
        0,
      ]);
    } else {
      ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
    }

    ctx.fill();
  }

  // ***************************************************************************************
  // drawSelectionLetter()
  // permet de dessiner la sélection des letters
  // ***************************************************************************************
  drawSelectionLetter(ctx, letter) {
    let unit = 6;

    if (this.state.font.px < 1) {
      unit = unit * this.state.font.px;
    }

    const rect = {
      x: letter.x,
      y: letter.y - unit,
      width: letter.width + 1,
      height: this.lineHeight - unit,
    };

    // Couleur de remplissage du rectangle
    ctx.fillStyle = '#595959';
    ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
  }

  // ***************************************************************************************
  // drawSearchWord()
  // permet de dessiner le mot recherché
  // ***************************************************************************************
  drawSearchWord(ctx, currentWord, color = '#9F6D0A') {
    ctx.fillStyle = color;

    const { wholeWord, caseSensitive, searchText } = this.state.search;

    const splittedTexts = searchText.split(' ');

    for (const text of splittedTexts) {
      let startIndex;
      if (wholeWord) {
        startIndex = 0;
      } else {
        if (caseSensitive) {
          startIndex = currentWord.text.indexOf(text);
        } else {
          startIndex = currentWord.text
            .toLowerCase()
            .indexOf(text.toLowerCase());
        }
      }

      if (startIndex === -1 || !currentWord.letters) continue;

      const endIndex = startIndex + text.length;
      const startX = currentWord.letters[startIndex].x;
      let width = 0;

      for (let i = startIndex; i < endIndex; i++) {
        width += currentWord.letters[i].width;
      }

      let unit = 6;

      if (this.state.font.px < 1) {
        unit = unit * this.state.font.px;
      }

      const rect = {
        x: startX,
        y: currentWord.y - unit,
        width: width,
        height: this.lineHeight - unit,
      };

      ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
      break;
    }
  }

  // ***************************************************************************************
  // drawRectangleWord()
  // dessine un rectangle autour du mot (x, y, largeur, hauteur)
  // ***************************************************************************************
  drawRectangleWord(startY, height) {
    const rect = {
      x: this.currentWord.x - 2,
      y: startY,
      width: this.currentWord.width - this.spaceWidth + 4,
      height: height,
    };

    this.foreCtx.beginPath();

    // Couleur de remplissage du rectange
    this.foreCtx.fillStyle = 'black';
    this.foreCtx.fillRect(rect.x, rect.y, rect.width, rect.height);

    // Ajouter une bordure autour du rectangle
    this.foreCtx.strokeStyle = '#959595'; // Couleur de bordure
    this.foreCtx.lineWidth = 2; // Largeur de la bordure
    this.foreCtx.roundRect(rect.x, rect.y, rect.width, rect.height, [3]);
    this.foreCtx.stroke();
  }

  // ***************************************************************************************
  // drawText()
  // Permet de dessiner le mot
  // ***************************************************************************************
  drawWord(ctx, word) {
    ctx.fillStyle = word.color;
    ctx.font = `${this.state.font.fontSize}px ${this.state.font.fontText}`;

    const metrics = ctx.measureText('I');
    const lineHeight =
      metrics.actualBoundingBoxAscent +
      metrics.actualBoundingBoxDescent +
      this.state.font.px;

    ctx.fillText(word.text, word.x, word.y + lineHeight);
  }

  // ***************************************************************************************
  // drawCursor()
  // Permet de dessiner le curseur
  // ***************************************************************************************
  drawCursor(x, y, height, color = 'red') {
    this.foreCtx.beginPath();
    this.foreCtx.moveTo(x, y + 2); // Point de départ de la ligne
    this.foreCtx.lineTo(x, y + height - 2); // Point d'arrivée de la ligne
    this.foreCtx.strokeStyle = color; // Couleur de la ligne
    this.foreCtx.lineWidth = 2; // Épaisseur de la ligne
    this.foreCtx.stroke();

    if (this.currentWord) {
      const lastChar = last(this.currentWord.letters);
      this._isCursorAtEndOfWord = lastChar ? lastChar.x <= x : false;
    }
    else {
      this._isCursorAtEndOfWord = false;
    }
  }

  // ***************************************************************************************
  // onResize()
  // cette fonction est appelée à chaque fois que l'application modifie la taille
  // du composant
  // ***************************************************************************************
  onResize(width, height) {
    if (this.foreCanvas && this.foreCanvas.current) {
      this.foreCanvas.current.width = width;
      this.foreCanvas.current.height = height;

      this.backCanvas.width = width;
      this.backCanvas.height = height;

      this.width = width;
      this.height = height;

      this.onRefreshCanvas(true);
    }
  }

  // ***************************************************************************************
  // onMove() Cette fonction doit être appelée à chaque fois que le curseur change de mot
  // ***************************************************************************************
  onMove() {
    if (this.props.onMove) {
      const currentWord = this.script[this.currentWordIndex];

      if (!currentWord) {
        return;
      }

      this.props.onMove(
        currentWord.startTime
      );
    }
  }

  // ***************************************************************************************
  // onSave() Cette fonction est appelée quand on appelle le raccourci SAVE
  // ***************************************************************************************
  onSave() {
    if (!this.props.onSave) {
      return;
    }

    // On renvoie toujours la transcription corrigée
    if (this.state.transcription.hasDisplayOriginal) {
      const { script, id } = this.state.transcription.corrected;
      if (script) {
        this.props.onSave(script, id);
      }
    } else {
      if (this.script) {
        this.props.onSave(this.script, this.state.transcription.id);
      }
    }
  }

  // ***************************************************************************************
  // onChange() Cette fonction doit être appelée à chaque fois que le script est modifié
  // ***************************************************************************************
  onChange(time, index, changed = true) {
    if (this.readonly) {
      return;
    }

    if (this.props.updateCP) {
      this.props.updateCP(this.script);
    }

    // Lancer la vérification du mot
    if (this.loaded) {
      this.onCheckLineByWord(this.script[index]);
    }

    this.forceRedraw = true; // on force le redessin
    this.cptCurs = 0; // on force l'affichage du curseur clignotant

    if (changed) {
      this.onCanvasChange();
    }

    if (this.props.onChange) {
      const scriptCloned = cloneTranscription(this.script);
      
      this.props.onChange(
        time,
        index,
        scriptCloned,
        this.state.transcription.id,
        changed
      );
    }
  }

  // ***************************************************************************************
  // removeEmptyWord Si on a créé un mot vide et qu'on fait une action ailleurs, on doit le supprimer
  // L'action est appelé quand on fait une action par le clavier (shortCut) ou par la souris (mouseDown)
  // ***************************************************************************************
  async removeEmptyWord(action) {
    if (!this.hasEmptyWord) {
      return;
    }

    this.hasEmptyWord = false;

    const actionsNotProceed = [
      'BACKSPACE',
      'ENTER',
      'DELETE',
      'PASTE',
      'SELECTA',
      'SUBMITWORD',
      'SUBMITSENTENCE',
      'SUBMITUNTILPUNCTUATION',
    ];

    // Si une de ces actions est en cours d'exécution, on ne fait rien
    // car on supprimera déjà le mot vide
    if (actionsNotProceed.includes(action)) {
      return;
    }

    const spaceWord = this.script.find((x) => x.text === '');

    if (!spaceWord) {
      return;
    }

    // on historise
    this.addNewActionForUndo('addSpace', spaceWord.index, 1, 0);

    // on supprime le mot vide
    this.script.splice(spaceWord.index, 1);

    this.recalculateIndexes();

    if (spaceWord.newline) {
      this.recalculateLines();
    }

    // on repositionne le curseur
    if (action === 'RIGHT') {
      this.currentWordIndex--;
      this.currentLetterIndex--;
    }

    if (
      (action === 'DOWN' || action === 'UP') &&
      this.currentLetterIndex === 0
    ) {
      if (action === 'DOWN') {
        this.currentLineIndex--;
      }

      const line = this.script.find(
        (x) => x.indexLine === this.currentLineIndex
      );

      if (line) {
        this.currentWordIndex = line.index;
      }
    }

    this.onRefreshCanvas(false);
  }

  // ***************************************************************************************
  // pasteWords permet de coller les mots dans la liste
  // ***************************************************************************************
  pasteWords(pasteTexts, fromClipboard) {
    // si le script est vierge
    if (!this.script.length) {
      this.addNewActionForUndo(
        'onPaste',
        0,
        0,
        pasteTexts.length > 1 ? pasteTexts.length : 0
      );

      this.script = pasteTexts.map((word, index) => {
        if (fromClipboard) {
          return {
            index,
            text: word,
            startTime: 0,
            endTime: 0,
            newline: false,
            color: '#FFFFFF',
            italic: false,
            markWord: 0,
            speakerId: null,
          };
        } else {
          word.index = index;
          word.startTime = 0;
          word.endTime = 0;
          return word;
        }
      });

      // si le dernier mot pushé est un mot vide, on le supprime
      if (last(this.script).text === '') {
        this.script.pop();
      }

      this.recalculateLines();

      const lastWord = last(this.script);

      this.currentWordIndex = lastWord.index;
      this.currentLineIndex = lastWord.indexLine;
      this.currentLetterIndex = null; // ce sera recalculé plus tard (dans createCursor)

      // Lancer la vérification des mots
      this.onCheckOnLines(0, lastWord.indexLine);

      this.onChange(0, 0);

      return;
    }

    // si on colle sur un ou plusieurs mots sélectionnés
    if (this.underSelection) {
      this.underSelection = false;

      if (this.lettersToSelect.length) {
        const nbWords = groupBy(this.lettersToSelect, (x) => x.indexWord);
        const keys = Object.keys(nbWords);

        // Si c'est un seul mot
        if (keys.length === 1) {
          const startLetter = first(this.lettersToSelect);
          const endLetter = last(this.lettersToSelect);

          const word = this.script[startLetter.indexWord];

          this.currentWordIndex = word.index;
          this.currentLineIndex = word.indexLine;
          this.currentLetterIndex = endLetter.indexLetter;

          // historiser
          this.addNewActionForUndo('onPasteLetter', word.index);

          const newText = fromClipboard
            ? join(pasteTexts, '')
            : join(
                pasteTexts.map((x) => x.text),
                ''
              );

          word.text =
            word.text.substring(0, startLetter.index) +
            newText +
            word.text.substring(endLetter.index + 1);

          this.onChange(word.startTime, word.index);
        }

        // TODO : est-ce qu'on gére si c'est plusieurs mots => faire en sorte d'être un mot insécable ?

        this.onRefreshCanvas(false);

        return;
      }

      const startWord = first(this.wordsToSelect);
      const endWord = last(this.wordsToSelect);

      // Historiser l'action
      this.addNewActionOnUnderSelectionForUndo(
        'onPaste',
        startWord.index,
        this.wordsToSelect,
        () => this.pasteWords(pasteTexts, fromClipboard),
        pasteTexts
      );

      const newWords = [];

      // Si on colle qu'un mot, on prend les mêmes startTime et endTime
      if (pasteTexts.length === 1) {
        const newWord = {
          ...startWord,
          text: fromClipboard ? first(pasteTexts) : first(pasteTexts).text,

          startTime: startWord.startTime,
          endTime: endWord.endTime,
          letters: [],
        };

        newWords.push(newWord);
      } else {
        // S'il y en a plusieurs, on va recalculer les timecodes

        const oldWord = {
          text: join(
            this.wordsToSelect.map((x) => x.text),
            ' '
          ),
          startTime: startWord.startTime,
          endTime: endWord.endTime,
        };

        for (let i = 0; i < pasteTexts.length; i++) {
          const newText = fromClipboard ? pasteTexts[i] : pasteTexts[i].text;
          let prevWord;

          let inOutTime = 0;
          if (i === 0) {
            prevWord = startWord;
            inOutTime = calculateTime(
              oldWord.startTime,
              oldWord.endTime,
              oldWord.text,
              newText
            );
          } else {
            prevWord = newWords[i - 1];
            inOutTime = calculateTime(
              prevWord.endTime,
              oldWord.endTime,
              oldWord.text,
              newText
            );
          }

          const newWord = {
            ...prevWord,
            text: newText,
            newline: i === 0 ? prevWord.newline : false,
            startTime: prevWord.endTime,
            endTime: inOutTime,
          };

          newWords.push(newWord);
        }
      }

      // si le dernier mot pushé est un mot vide, on le supprime
      if (last(newWords).text === '') {
        newWords.pop();
      }

      // supprimer les mots existants et ajouter les nouveaux mots
      const startIndex = startWord.index;
      const endIndex = endWord.index;
      this.replaceWords(startIndex, endIndex, newWords);
      this.onChange(startWord.startTime, startIndex);

      // Lancer la vérification des mots
      this.onCheckOnLines(first(newWords).indexLine, last(newWords).indexLine);

      return;
    }

    // on colle le mot là où le curseur est placé
    const currentText = this.currentWord.text;
    const currentIndex = this.currentWord.letters.findIndex(
      (l) => l.indexLetter === this.currentLetterIndex
    );

    // on ajoute dans l'historique des actions
    this.addNewActionForUndo(
      'onPaste',
      this.currentWord.index,
      0,
      currentText === '' ? pasteTexts.length - 1 : pasteTexts.length
    );

    // s'il y a qu'un mot à coller dans le mot
    if (pasteTexts.length === 1) {
      const pasteText = fromClipboard
        ? join(pasteTexts, ' ')
        : join(
            pasteTexts.map((x) => x.text),
            ' '
          );

      if (currentText === ' ') {
        this.currentWord.text = pasteText;
      } else {
        this.currentWord.text =
          currentText.substring(0, currentIndex) +
          pasteText +
          currentText.substring(currentIndex);
      }

      this.currentLetterIndex = null;

      this.onChange(this.currentWord.startTime, this.currentWord.index);

      return;
    }

    const oldWord = { ...this.currentWord };
    const newWords = [];

    // si
    if (oldWord.text.length !== 0 && oldWord.text !== ' ') {
      const firstWord = {
        ...this.currentWord,
        text: currentText.substring(0, currentIndex),
        letters: [],
        startTime: oldWord.startTime,
      };

      let inOutTime = calculateTime(
        oldWord.startTime,
        oldWord.endTime,
        oldWord.text,
        firstWord.text
      );

      firstWord.endTime = inOutTime;

      newWords.push(firstWord);
    }

    // Si cela vient du presse-papiers ou si ça vient des mots sélectionnés (action copier ou couper)
    if (fromClipboard) {
      pasteTexts.forEach((text) => {
        let prevWord = last(newWords);

        const startTime = prevWord ? prevWord.endTime : oldWord.startTime;

        const newWord = {
          ...this.currentWord,
          letters: [],
          text: text,
          startTime: startTime,
          newline: newWords.length === 0 ? oldWord.newline : false,
        };

        newWord.endTime = calculateTime(
          startTime,
          oldWord.endTime,
          oldWord.text,
          newWord.text
        );

        newWords.push(newWord);
      });
    } else {
      pasteTexts.forEach((word) => {
        let prevWord = last(newWords);

        const startTime = prevWord ? prevWord.endTime : oldWord.startTime;

        const newWord = {
          ...word,
          startTime: startTime,
          newline: newWords.length === 0 ? oldWord.newline : false,
        };

        newWord.endTime = calculateTime(
          startTime,
          oldWord.endTime,
          oldWord.text,
          newWord.text
        );

        newWords.push(newWord);
      });
    }

    // si le dernier mot pushé est un mot vide, on le supprime
    if (last(newWords).text === '') {
      newWords.pop();
    }

    // On va éviter de créer un mot vide
    if (currentText !== '') {
      const lastWord = {
        ...this.currentWord,
        text: currentText.substring(currentIndex),
        letters: [],
        startTime: last(newWords).endTime,
        endTime: oldWord.endTime,
      };

      if (lastWord.text.length === 0 || lastWord.text === ' ') {
        last(newWords).endTime = oldWord.endTime;
      } else {
        newWords.push(lastWord);
      }
    } else {
      last(newWords).endTime = oldWord.endTime;
    }

    // Replace
    this.replaceWords(oldWord.index, oldWord.index, newWords);

    this.wordsSelected = [];

    this.onChange(this.currentWord.startTime, this.currentWord.index);

    // Lancer la vérification des mots
    this.onCheckOnLines(first(newWords).indexLine, last(newWords).indexLine);
  }

  // ***************************************************************************************
  // On supprime les mots de la liste
  // ***************************************************************************************
  removeWordsInSelection(words, actionType, callback) {
    let firstWord = first(words);

    let prevWord = this.script[firstWord.index - 1];
    // si le mot est vide, on va aussi le supprimer
    if (prevWord?.text === '') {
      words.unshift(prevWord);
      firstWord = prevWord;

      prevWord = this.script[prevWord.index - 1];
    }

    // Historiser l'action
    this.addNewActionOnUnderSelectionForUndo(
      actionType,
      firstWord.index,
      words,
      callback
    );

    // On supprime les mots de la liste
    this.script.splice(firstWord.index, words.length);

    // On déselectionne
    this.underSelection = false;
    this.wordsToSelect = [];

    if (!this.script.length) {
      this.currentWord = null;
      this.currentLetter = null;

      this.setState({
        scrollValue: 0,
        currentTime: 0,
        currentPositionLine: 0,
        currentPositionWord: 0,
      });

      this.onChange(0, -1);
      return;
    }



    if(firstWord.newline || firstWord.index === 0) {
      let nextWord = this.script[firstWord.index];
      nextWord.index = firstWord.index;
      nextWord.startTime = firstWord.startTime;
      nextWord.indexLine = firstWord.indexLine;
      nextWord.newline = firstWord.index === 0 ? false : true;

      // On place le curseur sur le prochain mot
      this.currentWordIndex = nextWord.index;
      this.currentLineIndex = nextWord.indexLine;
      this.currentLetterIndex = 0;

      this.forceRecalculateLines = true;
      this.onChange(nextWord.startTime, nextWord.index);

      return;
    }

    prevWord.endTime = firstWord.startTime;

    // On place le curseur sur le précédent mot
    this.currentWordIndex = prevWord.index;
    this.currentLineIndex = prevWord.indexLine;
    this.currentLetterIndex = last(prevWord.letters).indexLetter;

    this.forceRecalculateLines = true;
    this.onChange(prevWord.startTime, prevWord.index);
  }

  // ***************************************************************************************
  // On supprime les lettres de la liste
  // ***************************************************************************************
  removeLettersInSelection(letters, actionType, callback) {
    const nbWords = groupBy(letters, (x) => x.indexWord);
    const keys = Object.keys(nbWords);
    const wordsSelected = this.script.filter((x) =>
      keys.includes(x.index.toString())
    );

    // On historise
    this.addNewActionOnUnderSelectionForUndo(
      actionType,
      first(wordsSelected).index,
      wordsSelected,
      callback
    );

    // Si c'est un seul mot
    if (keys.length === 1) {
      const startLetter = first(this.lettersToSelect);
      const endLetter = last(this.lettersToSelect);

      const word = this.script[startLetter.indexWord];

      word.text =
        word.text.substring(0, startLetter.index) +
        word.text.substring(endLetter.index + 1);

      // Placer le curseur sur le mot
      this.currentWordIndex = word.index;
      this.currentLineIndex = word.indexLine;
      this.currentLetterIndex = startLetter.indexLetter;

      // on désélectionne
      this.lettersToSelect = [];
      this.underSelection = false;

      this.onChange(word.startTime, word.index);

      return;
    } else {
      const wordsToDelete = [];
      const wordsToRegroup = [];

      for (const word of wordsSelected) {
        const lettersToDelete = this.lettersToSelect.filter(
          (x) => x.indexWord === word.index
        );

        if (lettersToDelete.length) {
          const startLetter = first(lettersToDelete);
          const endLetter = last(lettersToDelete);

          word.text =
            word.text.substring(0, startLetter.index) +
            word.text.substring(endLetter.index + 1);

          if (word.text.length === 0) {
            wordsToDelete.push(word);
          } else {
            wordsToRegroup.push(word);
          }
        }
      }

      if (wordsToDelete.length) {
        const firstIndex = first(wordsToDelete).index;

        // On supprime les mots de la liste
        this.script.splice(firstIndex, wordsToDelete.length);

        this.forceRecalculateLines = true;
      }

      if (wordsToRegroup.length) {
        const firstWord = first(wordsToRegroup);

        this.currentWordIndex = firstWord.index;
        this.currentLineIndex = firstWord.indexLine;
        this.currentLetterIndex =
          firstWord.letters[firstWord.text.length]?.indexLetter;

        if (wordsToRegroup.length === 2) {
          const lastWord = last(wordsToRegroup);

          firstWord.endTime = lastWord.endTime;
          firstWord.text += lastWord.text;

          const indexToDelete = this.script.findIndex(
            (x) => x.index === lastWord.index
          );

          this.script.splice(indexToDelete, 1);
        }

        this.lettersToSelect = [];
        this.underSelection = false;

        this.onChange(firstWord.startTime, firstWord.index);
        return;
      }
    }

    const firstWord = first(wordsSelected);
    let prevWord = this.script[firstWord.index - 1];

    // On place le curseur sur le précédent mot
    this.currentWordIndex = prevWord.index;
    this.currentLineIndex = prevWord.indexLine;
    this.currentLetterIndex = last(prevWord.letters).indexLetter;

    this.lettersToSelect = [];
    this.underSelection = false;

    this.onChange(prevWord.startTime, prevWord.index);
  }

  // ***************************************************************************************
  // addLettersToNewLine est une fonction permettant de créer un tableau de lettres dans chaque mot de la ligne
  // ***************************************************************************************
  addLettersToNewLine(prevLigne) {
    let indexLetter = 0;
    let currentX = this.metricX;

    prevLigne.forEach((word) => {
      const metricsWord = this.backCtx.measureText(word.text);
      word.width = metricsWord.width + this.spaceWidth;

      indexLetter = this.createLettersForWord(word, currentX, 0, indexLetter);

      currentX += word.width;
    });
  }

  // ***************************************************************************************
  // scrollToUp permet d'aller scroller vers le haut
  // ***************************************************************************************
  scrollToUp(word) {
    if (!word) {
      return;
    }

    if (
      this.scrollOffsetLine > 0 &&
      (word.y === 0 || word.y === this.metricY)
    ) {
      this.scrollTo(this.scrollOffsetLine - 1);
      return;
    }

    this.onRefreshCanvas(false);
  }

  // ***************************************************************************************
  // scrollToDown permet d'aller scroller vers le bas
  // ***************************************************************************************
  scrollToDown(word, nbLine = 1) {
    if (!word) {
      return;
    }

    if (word.y === 0 || this.height < word.endY + this.lineHeight) {
      this.scrollTo(this.scrollOffsetLine + nbLine, true);
      return;
    }

    this.onRefreshCanvas(false);
  }

  // ***************************************************************************************
  // scrollTo permet de scroll à la valeur donnée
  // ***************************************************************************************
  scrollTo(scrollValue, clear = true) {
    if (scrollValue < 0) {
      return;
    }

    this.scrollOffsetLine = scrollValue;
    this.changeScrollValueState(this.scrollOffsetLine);

    if (clear) {
      this.clearCoordinates();
    }
    this.onRefreshCanvas(false);

    if (!this.lockScroll) {
      this.onMove();
    }
  }

  // ***************************************************************************************
  // changeScrollValueState permet de changer la valeur du scroll dans le state
  // ***************************************************************************************
  changeScrollValueState(value) {
    this.setState({
      scrollValue: value,
    });
  }

  // ***************************************************************************************
  // setTranscription() appelée par l'application lors d'un chargement d'une nouvelle
  // transcription
  // ***************************************************************************************
  setTranscription(json, id, type, description, file, lang) {
    this.script = this.initScript(json, id, type, description, file) ?? [];
    this.readonly = id > 0 ? this.props.readonly : true;
    
     if (this.script && this.script.length && this.props.updateCP && !this.readonly) {
       this.props.updateCP(this.script);

       if (this.grammalecte && this.grammalecte.lang !== lang) {
         this.grammalecte.setLang(lang);
       }
    }

    this.setState((prevState) => ({
      transcription: {
        ...prevState.transcription,
        id,
        description,
        lang,
        hasDisplayOriginal: false,
        corrected: {
          id,
          description,
        },
      },
    }));

    this.loaded = false;
    this.forceRedraw = true;
    this.onChange(0, this.script.length ? 0 : -1, false);
  }

  // ***************************************************************************************
  // setOriginalTranscription() appelée par l'application lors d'un chargement de la transcription originelle
  // ***************************************************************************************
  setOriginalTranscription(json, id, type, description, file) {
    const originalTranscription =
      this.initScript(json, id, type, description, file) ?? [];

    this.setState((prevState) => ({
      transcription: {
        ...prevState.transcription,
        original: {
          id,
          description,
          script: originalTranscription,
        },
      },
    }));
  }

  // ***************************************************************************************
  // initScript() permet d'initialiser l'objet script
  // ***************************************************************************************
  initScript(json, id, type, description, file) {
    if (json) {
      switch (type) {
        // obsoléte
        //case 0: // conversion script type 0
        //  return convertTranscriptionScriptType0(json);

        case -1:
          return cloneDeep(json);

        default:
          this.setState({
            popup: {
              ...this.state.popup,
              display: true,
              showIcon: true,
              text: {
                fr: "La conversion du fichier n'est pas possible",
                en: 'The file cannot be converted',
              },
            },
          });

          return null;
      }
    }
  }

  // ***************************************************************************************
  // setCommonErrors() appelée par l'application lors d'un chargement d'une nouvelle
  // liste d'erreurs de mots
  // ***************************************************************************************
  setCommonErrors(blob) {
    this.commonErrors = blob;
  }

  // ***************************************************************************************
  // onCanvasChange() est appelée à chaque fois qu'on a fait une modification sur le canvas
  // ***************************************************************************************
  onCanvasChange(force = false) {
    this.onSearchChange(this.state.search.searchText);

    // On recalcule des index
    if (force || this.state.totalWords !== this.script.length) {
      this.recalculateIndexes();
    }

    // on recalcule les lignes
    if (force || this.forceRecalculateLines) {
      this.recalculateLines();
      this.forceRecalculateLines = false;
    }
  }

  // ***************************************************************************************
  // onClosePopup() permet de fermer la popup
  // ***************************************************************************************
  onClosePopup() {
    this.setState({
      popup: {
        display: false,
        title: '',
        text: '',
        buttons: [],
        showIcon: false,
        icon: null,
      },
    });
  }

  isCursorAtEndOfWord() {
    return {wordIndex: this.currentWordIndex, isCursorAtEndOfWord :this._isCursorAtEndOfWord};
  }

  onIdentifySpeakerDialogues(speaker) {
    const { show, speakerId } = this.state.identifySpeaker;

    if (show) {
      if (speakerId === speaker.id) {
        this.setState({
          identifySpeaker: {
            show: false,
            speakerId: null,
            color: null,
          },
        });

        this.onRefreshCanvas();

        return;
      }
    }

    const color = getColorByShortcut(speaker.color);

    this.setState({
      identifySpeaker: {
        show: true,
        speakerId: speaker.id,
        color: color ? color.hex : '#CCCCCC',
      },
    });

    const word = this.script.find((x) => x.speakerId === speaker.id);

    if (word) {
      this.currentWordIndex = word.index;
      this.currentLineIndex = word.indexLine;
      this.currentLetterIndex = 0;

      const goToWord = this.script[this.currentWordIndex];
      if (goToWord.y === 0 || this.height < goToWord.y + this.lineHeight) {
        this.scrollTo(this.currentLineIndex);
      }

      this.onMove();
    }

    this.onRefreshCanvas();
  }

  render() {
    const lang = this.context.language;
    const stimecode = this.RenderTimeCode(this.state.currentTime ?? 0);
    return (
      <div className="transcript-full-div" id="idTranscript">
        <div
          className={`transcript-title-div ${
            this.state.transcription.hasDisplayOriginal ? 'title-active' : ''
          }`}
        >
          {lang === 'fr' ? 'TRANSCRIPTION ORIGINALE' : 'ORIGINAL TRANSCRIPTION'}
        </div>
        <div
          className={`transcript-search-div ${
            this.state.search.showSearch ? 'search-active' : ''
          }`}
        >
          <Search
            ref={this.searchRef}
            search={this.state.search}
            onSearchClose={this.onSearchClose}
            onSearchChange={this.onSearchChange}
            onPrevPosition={this.onPrevPositionSearch}
            onNextPosition={this.onNextPositionSearch}
            onShowReplace={() => {
              this.setState({
                search: {
                  ...this.state.search,
                  showReplace: !this.state.search.showReplace,
                },
              });
            }}
            onCaseSensitive={this.onSearchCaseSensitive}
            onWholeWord={this.onSearchWholeWord}
            onReplaceOne={this.onReplaceOne}
            onReplaceAll={this.onReplaceAll}
            readonly={this.readonly}
          />
        </div>
        <div
          className={`transcript-top-div ${
            this.state.search.showSearch ? 'search-active' : ''
          }`}
        >
          <div
            className="transcript-text-div"
            id="textDiv"
            tabIndex={0}
            onBlur={this.onBlur}
          >
            <canvas
              ref={this.foreCanvas}
              className="foreCanvas"
              onContextMenu={this.onShowContextMenu}
              onClick={this.onClick}
              onDoubleClick={this.onDoubleClick}
              onMouseUp={this.onMouseUp}
              onMouseDown={this.onMouseDown}
              onMouseMove={this.onMouseMove}
            />
          </div>
          <div className="transcript-scroll-div">
            <input
              type="range"
              min="0"
              max={this.state.maxScrollValue}
              value={this.state.scrollValue}
              onKeyDown={this.onScrollKeyDown}
              onChange={this.onHandleChangeScroll}
              orient="vertical"
            />
          </div>
        </div>
        <div className="transcript-bottom-div">
          <div className="row">
            <div className="col">
              <p>
                {lang === 'fr' ? 'Ligne' : 'Line'} :{' '}
                {this.state.currentPositionLine}
              </p>
              <p>
                {lang === 'fr' ? 'Mot' : 'Word'} :{' '}
                {this.state.currentPositionWord}
              </p>
            </div>
            <div className="col">
              {stimecode}
            </div>
          </div>
          <div className="row">
            <div className="col">
              <p>
                {this.state.totalLines} {lang === 'fr' ? 'lignes' : 'lines'}
              </p>
              <p>
                {this.state.totalWords} {lang === 'fr' ? 'mots' : 'words'}
              </p>
              <p className="pl-5 pink">
                {this.state.totalWordsInError > 0
                  ? `${this.state.totalWordsInError} ${
                      lang === 'fr' ? 'mots en erreur' : 'words in error'
                    }`
                  : ''}
              </p>
              <div className="pl-5 pink">
                <HourglassIcon correcting={this.correcting} />
              </div>
            </div>
            <div className="col">
              {' '}
              <p>
                {this.state.transcription.id}-
                {this.state.transcription.description}
              </p>
            </div>
          </div>
        </div>

        <SimplePopup
          display={this.state.popup.display}
          title={this.state.popup.title}
          text={this.state.popup.text}
          onCancel={this.onClosePopup}
          buttons={this.state.popup.buttons}
          showIcon={this.state.popup.showIcon}
          icon={this.state.popup.icon}
        />

        <ContextMenu
          contextMenu={this.state.contextMenu}
          onApplyCorrection={this.onApplyCorrection}
          onApplyCorrectionAll={this.onApplyCorrectionAll}
          onAddWordToDictionary={this.onAddWordToDictionary}
          onIgnoreWordForCorrection={this.onIgnoreWordForCorrection}
          onIgnoreSuggestForCorrection={this.onIgnoreSuggestForCorrection}
          script={this.script}
        />

        <SpeakerMenu
          ref={this.speakerMenuRef}
          speakers={this.props.speakers}
          lang={lang}
          onSelectSpeaker={this.onSelectSpeaker}
          onClose={() => this.onCloseSpeakerMenu()}
        />
      </div>
    );
  }

  RenderTimeCode(currentTime) {
  
    return <p>{V2_ConvertSecondToTimeCodeStringFromAsset(currentTime, this.props.timecodeAsset, this.props.playerparams?.displaytcms)}</p>;

  }
}


// Set cursor
Transcript.prototype.onMoveCursorLetterByLetter = onMoveCursorLetterByLetter;
Transcript.prototype.onMoveCursorToLeft = onMoveCursorToLeft;
Transcript.prototype.onMoveCursorToRight = onMoveCursorToRight;
Transcript.prototype.onMoveCursorToDown = onMoveCursorToDown;
Transcript.prototype.onMoveCursorToUp = onMoveCursorToUp;
Transcript.prototype.onPreviousPositionCursor = onPreviousPositionCursor;
Transcript.prototype.onGoToStartOrEndOfWord = onGoToStartOrEndOfWord;
Transcript.prototype.onGoToHomeOrEnd = onGoToHomeOrEnd;
Transcript.prototype.onGoToPageUpOrDown = onGoToPageUpOrDown;
Transcript.prototype.onGoToSentence = onGoToSentence;
Transcript.prototype.onGoToSpeakerDialogue = onGoToSpeakerDialogue;

// Scroll
Transcript.prototype.onHandleChangeScroll = onHandleChangeScroll;
Transcript.prototype.onWheel = onWheel;
Transcript.prototype.onScrollKeyDown = onScrollKeyDown;
Transcript.prototype.onZoom = onZoom;

// Mouse
Transcript.prototype.onDoubleClick = onDoubleClick;
Transcript.prototype.onMouseMove = onMouseMove;
Transcript.prototype.onMouseUp = onMouseUp;
Transcript.prototype.onMouseDown = onMouseDown;
Transcript.prototype.onStopMoving = onStopMoving;
Transcript.prototype.onBlur = onBlur;
Transcript.prototype.onRemoveMoving = onRemoveMoving;
Transcript.prototype.onClick = onClick;

// Keyboard
Transcript.prototype.onBackspace = onBackspace;
Transcript.prototype.onBackspaceLeftToRight = onBackspaceLeftToRight;
Transcript.prototype.onCopy = onCopy;
Transcript.prototype.onCut = onCut;
Transcript.prototype.onDelete = onDelete;
Transcript.prototype.onDeleteLeftToRight = onDeleteLeftToRight;
Transcript.prototype.onDeleteWord = onDeleteWord;
Transcript.prototype.onDeleteLine = onDeleteLine;
Transcript.prototype.onDeleteWordsUntil = onDeleteWordsUntil;
Transcript.prototype.onEnter = onEnter;
Transcript.prototype.onMarkWord = onMarkWord;
Transcript.prototype.onPaste = onPaste;
Transcript.prototype.onMoveWordByWord = onMoveWordByWord;
Transcript.prototype.onSelect = onSelect;
Transcript.prototype.onSelectLeftOrRight = onSelectLeftOrRight;
Transcript.prototype.onSelectTopOrBottom = onSelectTopOrBottom;
Transcript.prototype.onSetColor = onSetColor;
Transcript.prototype.onSelectWithCtrlA = onSelectWithCtrlA;
Transcript.prototype.onSelectSentence = onSelectSentence;
Transcript.prototype.onTab = onTab;
Transcript.prototype.onChangeTranscription = onChangeTranscription;
Transcript.prototype.onSubmitWord = onSubmitWord;
Transcript.prototype.onSubmitSentence = onSubmitSentence;
Transcript.prototype.onCancelSubmittedWords = onCancelSubmittedWords;
Transcript.prototype.onSelectLetterByLetter = onSelectLetterByLetter;

// Search
Transcript.prototype.onSearchClose = onSearchClose;
Transcript.prototype.onSearchChange = onSearchChange;
Transcript.prototype.onPrevPositionSearch = onPrevPositionSearch;
Transcript.prototype.onNextPositionSearch = onNextPositionSearch;
Transcript.prototype.onReplaceOne = onReplaceOne;
Transcript.prototype.onReplaceAll = onReplaceAll;
Transcript.prototype.onSearchCaseSensitive = onSearchCaseSensitive;
Transcript.prototype.onSearchWholeWord = onSearchWholeWord;

// Undo/Redo
Transcript.prototype.addNewActionForUndo = addNewActionForUndo;
Transcript.prototype.addActionForUndoOrRedo = addActionForUndoOrRedo;
Transcript.prototype.addNewActionOnUnderSelectionForUndo =
  addNewActionOnUnderSelectionForUndo;
Transcript.prototype.onUndoOrRedo = onUndoOrRedo;
Transcript.prototype.onReplaceAllWhenUndoOrRedo = onReplaceAllWhenUndoOrRedo;
Transcript.prototype.onUnderSelectionWhenUndoOrRedo =
  onUnderSelectionWhenUndoOrRedo;
Transcript.prototype.onRedrawAfterRedoOrUndo = onRedrawAfterRedoOrUndo;

// Corrector
Transcript.prototype.onScriptChecker = onScriptChecker;
Transcript.prototype.onWordChecker = onWordChecker;
Transcript.prototype.onWordCheckerEnglish = onWordCheckerEnglish;
Transcript.prototype.onCloseContextMenu = onCloseContextMenu;
Transcript.prototype.onShowContextMenu = onShowContextMenu;
Transcript.prototype.onApplyCorrection = onApplyCorrection;
Transcript.prototype.onApplyCorrectionForSpelling =
  onApplyCorrectionForSpelling;
Transcript.prototype.onApplyCorrectionForSpellingEnglish =
  onApplyCorrectionForSpellingEnglish;
Transcript.prototype.onApplyCorrectionForGrammar = onApplyCorrectionForGrammar;
Transcript.prototype.onApplyCorrectionAll = onApplyCorrectionAll;
Transcript.prototype.onCheckLine = onCheckLine;
Transcript.prototype.onCheckLineByWord = onCheckLineByWord;
Transcript.prototype.onCheckOnLines = onCheckOnLines;
Transcript.prototype.onGoToWordInError = onGoToWordInError;
Transcript.prototype.onAddWordToDictionary = onAddWordToDictionary;
Transcript.prototype.onIgnoreWordForCorrection = onIgnoreWordForCorrection;
Transcript.prototype.onIgnoreSuggestForCorrection =
  onIgnoreSuggestForCorrection;

// char
Transcript.prototype.addChar = addChar;
Transcript.prototype.addHebrewOrArabicChar = addHebrewOrArabicChar;
Transcript.prototype.addSpace = addSpace;
Transcript.prototype.addHyphen = addHyphen;
Transcript.prototype.groupWordsByUnsecableSpace = groupWordsByUnsecableSpace;
Transcript.prototype.groupWordsWithoutSpace = groupWordsWithoutSpace;
Transcript.prototype.onConversionToInitial = onConversionToInitial;
Transcript.prototype.onUpperOrLowerCase = onUpperOrLowerCase;
Transcript.prototype.onReturnToLineWithHypen = onReturnToLineWithHypen;
Transcript.prototype.addPeriod = addPeriod;
Transcript.prototype.removeUnsecableSpace = removeUnsecableSpace;
Transcript.prototype.addQuotes = addQuotes;
Transcript.prototype.addApostrophes = addApostrophes;
Transcript.prototype.addOrRemoveLetter = addOrRemoveLetter;
Transcript.prototype.invertPeriodAndComma = invertPeriodAndComma;
Transcript.prototype.invertALetter = invertALetter;
Transcript.prototype.hyphenateTwoWords = hyphenateTwoWords;
Transcript.prototype.replaceHyphenate = replaceHyphenate;
Transcript.prototype.addOrRemoveLetterWithApostrophe =
  addOrRemoveLetterWithApostrophe;
Transcript.prototype.addOrRemoveApostropheToLetter =
  addOrRemoveApostropheToLetter;
Transcript.prototype.replaceLetter = replaceLetter;
Transcript.prototype.addOrRemoveLeToWord = addOrRemoveLeToWord;
Transcript.prototype.addScriptToNewUndo = addScriptToNewUndo;

// Speaker
Transcript.prototype.onShowSpeakerMenu = onShowSpeakerMenu;
Transcript.prototype.onCloseSpeakerMenu = onCloseSpeakerMenu;
Transcript.prototype.onSelectSpeaker = onSelectSpeaker;


Transcript.defaultProps = {
  readonly: false,
  noCursor: false,
  showPosition: false,
  speakers:[],
  showSpeakers: true,
}

export default Transcript;
